import { Divider } from 'antd';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import moment from 'moment';

const PatientProfileCard = ({
  PatientName,
  PatientPhoneNo,
  PatientGender,
  PatientBirthDate,
  PatientRegistrationNo,
  PatientDateOfConsultation,
  PatientConsultatingDoctor,
  PatientID,
  treatmentDetails,
  CcPaperDetail,
  isEditingChiefComplaint,
  tempChiefComplaint,
  setIsEditingChiefComplaint,
  setTempChiefComplaint,
  IsFilledForm,
  MedicalDetail,
}) => {
  const chiefComplaintFromState = CcPaperDetail?.personalDetails?.filter(
    item => item?.personalDetilsKey === 'ChiefComplaints'
  )[0]?.value;

  return (
    <div
      className="card-box profile-header my-2"
      style={{
        background: '#ffffff',
        borderRadius: '12px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
        padding: '20px',
        border: '1px solid #e8e8e8',
      }}
    >
      <div className="row">
        <div className="col-md-12">
          <div className="profile-view">
            {/*<div className="profile-img-wrap-sm">
               <div
                className="profile-img-sm"
                style={{
                  position: 'relative',
                  borderRadius: '50%',
                  overflow: 'hidden',
                  border: '3px solid #f3f4f6',
                }}
              >
                <Link to="#">
                  <img
                    className="avatar"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                    src={StaffProfileIcon}
                    alt="#"
                  />
                </Link>
              </div>
            </div>*/}
            <div className="profile-basic" style={{ backgroundColor: 'transparent' }}>
              <div className="row align-items-center">
                <div className="col-md-6">
                  {/* <div className="profile-info-left"> */}
                  <h3
                    className="user-name m-t-0 mb-0"
                    style={{
                      fontSize: '24px',
                      fontWeight: '600',
                      color: '#111827',
                      marginBottom: '4px',
                      letterSpacing: '-0.01em',
                    }}
                  >
                    {PatientName || '---'}
                  </h3>
                  {/* </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
      <Divider
        style={{
          borderColor: '#e5e7eb',
          margin: '16px 0',
        }}
      />

      <div className="row">
        <div className="col-md-12">
          <div className="profile-view">
            <div className="" style={{ backgroundColor: 'transparent' }}>
              <div className="row" style={{ gap: '16px 0' }}>
                <div className="col-md-4">
                  <div
                    style={{
                      padding: '16px',
                      background: '#f9fafb',
                      borderRadius: '8px',
                      border: '1px solid #e5e7eb',
                      height: '100%',
                    }}
                  >
                    <div style={{ marginBottom: '16px' }}>
                      <span
                        style={{
                          fontSize: '12px',
                          fontWeight: '600',
                          color: '#6b7280',
                          textTransform: 'uppercase',
                          letterSpacing: '0.05em',
                          display: 'block',
                          marginBottom: '6px',
                        }}
                      >
                        Phone
                      </span>
                      <span
                        style={{
                          fontSize: '15px',
                          color: '#111827',
                          fontWeight: '500',
                        }}
                      >
                        {PatientPhoneNo || '---'}
                      </span>
                    </div>
                    <div>
                      <span
                        style={{
                          fontSize: '12px',
                          fontWeight: '600',
                          color: '#6b7280',
                          textTransform: 'uppercase',
                          letterSpacing: '0.05em',
                          display: 'block',
                          marginBottom: '6px',
                        }}
                      >
                        Gender
                      </span>
                      <span
                        style={{
                          fontSize: '15px',
                          color: '#111827',
                          fontWeight: '500',
                        }}
                      >
                        {PatientGender || '---'}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div
                    style={{
                      padding: '16px',
                      background: '#f9fafb',
                      borderRadius: '8px',
                      border: '1px solid #e5e7eb',
                      height: '100%',
                    }}
                  >
                    <div style={{ marginBottom: '16px' }}>
                      <span
                        style={{
                          fontSize: '12px',
                          fontWeight: '600',
                          color: '#6b7280',
                          textTransform: 'uppercase',
                          letterSpacing: '0.05em',
                          display: 'block',
                          marginBottom: '6px',
                        }}
                      >
                        Birthdate (DD/MM/YYYY)
                      </span>
                      <span
                        style={{
                          fontSize: '15px',
                          color: '#111827',
                          fontWeight: '500',
                        }}
                      >
                        {(PatientBirthDate &&
                          moment(PatientBirthDate).format('DD/MM/YYYY')) ||
                          '---'}
                      </span>
                    </div>
                    <div>
                      <span
                        style={{
                          fontSize: '12px',
                          fontWeight: '600',
                          color: '#6b7280',
                          textTransform: 'uppercase',
                          letterSpacing: '0.05em',
                          display: 'block',
                          marginBottom: '6px',
                        }}
                      >
                        Case Paper Number
                      </span>
                      <span
                        style={{
                          fontSize: '15px',
                          color: '#111827',
                          fontWeight: '500',
                        }}
                      >
                        {PatientRegistrationNo || '---'}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div
                    style={{
                      padding: '16px',
                      background: '#f9fafb',
                      borderRadius: '8px',
                      border: '1px solid #e5e7eb',
                      height: '100%',
                    }}
                  >
                    <div style={{ marginBottom: '16px' }}>
                      <span
                        style={{
                          fontSize: '12px',
                          fontWeight: '600',
                          color: '#6b7280',
                          textTransform: 'uppercase',
                          letterSpacing: '0.05em',
                          display: 'block',
                          marginBottom: '6px',
                        }}
                      >
                        Date of Booking (DD/MM/YYYY)
                      </span>
                      <span
                        style={{
                          fontSize: '15px',
                          color: '#111827',
                          fontWeight: '500',
                        }}
                      >
                        {(PatientDateOfConsultation &&
                          moment(PatientDateOfConsultation, ['DD/MM/YYYY', "YYYY-MM-DD"]).format(
                            'DD/MM/YYYY'
                          )) ||
                          '---'}
                      </span>
                    </div>
                    <div>
                      <span
                        style={{
                          fontSize: '12px',
                          fontWeight: '600',
                          color: '#6b7280',
                          textTransform: 'uppercase',
                          letterSpacing: '0.05em',
                          display: 'block',
                          marginBottom: '6px',
                        }}
                      >
                        Consulting Doctor
                      </span>
                      <span
                        style={{
                          fontSize: '15px',
                          color: '#111827',
                          fontWeight: '500',
                        }}
                      >
                        {PatientConsultatingDoctor || '---'}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-12">
                  <div
                    style={{
                      padding: '12px 20px',
                      background: '#4f46e5',
                      borderRadius: '8px',
                      border: 'none',
                    }}
                  >
                    <span
                      style={{
                        fontSize: '11px',
                        fontWeight: '600',
                        color: 'rgba(255,255,255,0.8)',
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em',
                        display: 'block',
                        marginBottom: '4px',
                      }}
                    >
                      Treatment Selected by Patient
                    </span>
                    <span
                      style={{
                        fontSize: '15px',
                        color: '#ffffff',
                        fontWeight: '500',
                        lineHeight: '1.4',
                      }}
                    >
                      {treatmentDetails}
                    </span>
                  </div>
                </div>

                <div className="col-md-12">
                  <div
                    style={{
                      padding: '16px',
                      background: '#f3f4f6',
                      borderRadius: '8px',
                      border: '1px solid #e5e7eb',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        gap: '12px',
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <span
                          style={{
                            fontSize: '12px',
                            fontWeight: '600',
                            color: '#6b7280',
                            textTransform: 'uppercase',
                            letterSpacing: '0.05em',
                            display: 'block',
                            marginBottom: '8px',
                          }}
                        >
                          Chief Complaint With Duration
                        </span>
                        {!isEditingChiefComplaint ? (
                          <div
                            style={{ display: 'flex', alignItems: 'center', gap: '12px' }}
                          >
                            <span
                              style={{
                                fontSize: '16px',
                                color: '#111827',
                                fontWeight: '500',
                                lineHeight: '1.6',
                                flex: 1,
                              }}
                            >
                              {chiefComplaintFromState || '---'}
                            </span>
                            {!IsFilledForm && (
                              <FeatherIcon
                                icon="edit-2"
                                style={{
                                  cursor: 'pointer',
                                  color: '#6b7280',
                                  width: '35px',
                                  height: '35px',
                                  padding: '4px',
                                  borderRadius: '4px',
                                  transition: 'all 0.2s ease',
                                }}
                                onMouseEnter={e => {
                                  e.target.style.color = '#4f46e5';
                                  e.target.style.background = '#eef2ff';
                                }}
                                onMouseLeave={e => {
                                  e.target.style.color = '#6b7280';
                                  e.target.style.background = 'transparent';
                                }}
                                onClick={() => {
                                  const currentValue = chiefComplaintFromState || '';
                                  setTempChiefComplaint(currentValue);
                                  setIsEditingChiefComplaint(true);
                                }}
                              />
                            )}
                          </div>
                        ) : (
                          <div style={{ flex: 1 }}>
                            <textarea
                              value={tempChiefComplaint}
                              onChange={e => setTempChiefComplaint(e.target.value)}
                              style={{
                                width: '100%',
                                minHeight: '80px',
                                padding: '12px',
                                fontSize: '16px',
                                fontWeight: '500',
                                lineHeight: '1.6',
                                color: '#111827',
                                border: '1px solid #d1d5db',
                                borderRadius: '6px',
                                resize: 'vertical',
                                fontFamily: 'inherit',
                              }}
                              placeholder="Enter Chief Complaint..."
                              autoFocus
                            />
                            <div
                              style={{
                                display: 'flex',
                                gap: '8px',
                                marginTop: '8px',
                                justifyContent: 'flex-end',
                              }}
                            >
                              <FeatherIcon
                                icon="x"
                                style={{
                                  cursor: 'pointer',
                                  color: '#6b7280',
                                  width: '35px',
                                  height: '35px',
                                  padding: '6px',
                                  borderRadius: '4px',
                                  transition: 'all 0.2s ease',
                                }}
                                onMouseEnter={e => {
                                  e.target.style.color = '#dc2626';
                                  e.target.style.background = '#fef2f2';
                                }}
                                onMouseLeave={e => {
                                  e.target.style.color = '#6b7280';
                                  e.target.style.background = 'transparent';
                                }}
                                onClick={() => {
                                  setIsEditingChiefComplaint(false);
                                  setTempChiefComplaint('');
                                }}
                              />
                            </div>
                            <p style={{ fontSize: '12px', color: '#6b7280', marginTop: '8px', marginBottom: 0 }}>
                              Changes will be saved when you submit the form.
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};

export default PatientProfileCard;